import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import { useForm } from "react-hook-form"; // Import useForm from react-hook-form

import Addunits from "../../core/modals/inventory/addunits";
import AddCategory from "../../core/modals/inventory/addcategory";
import AddBrand from "../../core/modals/addbrand";
import { GetRequest, PatchRequest } from "../../Api/ApiFunctions";
import { ApiUrl, ConfUrl } from "../../Api/EndPoints";
import MultipleImage from "./Components/MultipleImage";
import {
  ConfImageUploadService,
  flattenObject,
  ImageDataModalRequired,
  transformObject,
} from "./constants";
import TextArea from "./Components/TextArea";
import MultiplePoints from "./Components/MultiplePoints";

const KurversValves = () => {
  const route = all_routes;
  const [Responsibilities, setResponsibilities] = useState([]);
  const [banner, setBanner] = useState([]);
  const [section2, setSection2] = useState([]);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    // getValues,
    control,
    // reset,
    formState: { isSubmitting },
  } = useForm(); // Set up useForm

  const fetchData = async () => {
    const res = await GetRequest(`${ApiUrl.configuration}${ConfUrl.valves}`);
    // if (res) {
    //   let data = res?.value;
    //   setValue("confId", res.id);
    //   setResponsibilities(data?.products ?? {});
    //   // setDataSource(res);
    // }
    if (res) {
      setBanner(res?.value?.banner ? res.value.banner : []);
      setSection2(res?.value?.section2 ? [res.value.section2] : []);
      const val = flattenObject(res?.value, "", [
        "banner",
        "section2",
        "valves",
      ]);
      Object.keys(val).forEach((key) => {
        setValue(key, val[key]);
      });
      setResponsibilities(res?.value?.valves ?? []);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSubmit = async (data) => {
    let Req = transformObject(data);
    Req.valves = Responsibilities;

    Req.banner = await Promise.all(
      banner.map(async (it) => {
        let imgKey = null;
        if (it.image instanceof File) {
          imgKey = await ConfImageUploadService(it.image);
        }
        return {
          key: it.key,
          image: imgKey ? imgKey : it.image,
          heading: it.heading,
          subHeading: it.subHeading,
        };
      })
    );

    if (section2?.length > 0) {
      let imgKey = null;
      if (section2[0]?.image instanceof File) {
        imgKey = await ConfImageUploadService(section2[0]?.image);
      }
      Req.section2 = {
        key: section2[0]?.key,
        image: imgKey ? imgKey : section2[0]?.image,
        heading: section2[0]?.heading,
        subHeading: section2[0]?.subHeading,
      };
    }

    const resp = await PatchRequest(
      `${ApiUrl.configuration}${ConfUrl.valves}`,
      Req
    );
    if (resp) {
      navigate(route.jobapplication);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Kurvers Valves</h4>
              {/* <h6>Create new Career</h6> */}
            </div>
          </div>
        </div>
        {/* /add */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body add-product pb-0">
              <div className="row">
                {/* <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("heading", {
                        required: "title is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Description</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("description", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div> */}
                <h4>
                  <u>Banner</u>
                </h4>
                <div className="col-12">
                  <MultipleImage
                    id="banner"
                    dataSource={banner}
                    setDataSource={setBanner}
                    DataRequired={[
                      ImageDataModalRequired.image,
                      ImageDataModalRequired.heading,
                      ImageDataModalRequired.description,
                      // ImageDataModalRequired.buttonText,
                      // ImageDataModalRequired.buttonLink,
                    ]}
                  />
                </div>

                <h4>
                  <u>Section 1</u>
                </h4>

                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Heading - left</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("section1_headingLeft", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Heading - right</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("section1_headingRight", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Sub Heading - right</label>
                    {/* <input
                      type="text"
                      className="form-control"
                      {...register("section1_subHeadingRight", {
                        required: "location is required",
                      })}
                    /> */}
                    <TextArea
                      control={control}
                      id="section1_subHeadingRight"
                      placeholder="Section - right Content"
                    />
                  </div>
                </div>

                <div className="col-12">
                  <label className="form-label">Section - left Content</label>
                  <TextArea
                    control={control}
                    id="section1_subHeadingLeft"
                    placeholder="Section - left Content"
                  />
                </div>

                <h4>
                  <u>Section 2</u>
                </h4>
                <div className="col-12">
                  <MultipleImage
                    id="section2"
                    dataSource={section2}
                    setDataSource={setSection2}
                    DataRequired={[
                      ImageDataModalRequired.image,
                      ImageDataModalRequired.heading,
                      ImageDataModalRequired.description,
                      // ImageDataModalRequired.buttonText,
                      // ImageDataModalRequired.buttonLink,
                    ]}
                    DataLimit={1}
                  />
                </div>

                <MultiplePoints
                  Responsibilities={Responsibilities}
                  setResponsibilities={setResponsibilities}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="btn-addproduct mb-4">
              <button type="button" className="btn btn-cancel me-2">
                Cancel
              </button>

              <button
                type="submit"
                className="btn btn-submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <span className="spinner-border spinner-border-sm"></span>
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </form>
        {/* /add */}
      </div>
      <Addunits />
      <AddCategory />
      <AddBrand />
    </div>
  );
};

export default KurversValves;
